import { apiClient } from '@/lib/api/client'

/** SOLY-IMPORT-003 S11 — mirrors Soly.Sales.Domain.SupplyModes. */
export type SupplyMode = 'buy' | 'make' | 'none' | 'unqualified'

/** Mirrors LineSupplyDto. `offeredForPurchase` is the server's picker rule; `locked`: a supplier already holds the line. */
export interface LineSupply {
  mode: SupplyMode
  supplierId: string | null
  supplierReference: string | null
  requiredQuantity: number | null
  requiredUnit: string | null
  offeredForPurchase: boolean
  locked: boolean
}

/** Mirrors SaleSupplyLineDto. `origin*`: what the import file said, null for a typed line. */
export interface SaleSupplyLine {
  id: string
  displayOrder: number
  kind: string
  title: string
  categoryId: string | null
  category: string | null
  quantity: number | null
  lineTotalBeforeTax: number | null
  sourceSystem: string | null
  originReference: string | null
  originQuantity: number | null
  originUnit: string | null
  supply: LineSupply
}

export interface SaleSupply {
  salesOrderId: string
  totalBeforeTax: number | null
  totalWithTax: number | null
  canWrite: boolean
  lines: SaleSupplyLine[]
}

export interface SupplyOption {
  id: string
  name: string
}

/** The body of a supply change: the lines and the supply they all take. Buy details are dropped server-side for any other mode. */
export interface SetLinesSupplyBody {
  lineIds: string[]
  mode: SupplyMode
  supplierId?: string | null
  supplierReference?: string | null
  requiredQuantity?: number | null
  requiredUnit?: string | null
  /** A bulk change: each line keeps its own reference, quantity and unit; only mode and supplier change. */
  keepLineDetails?: boolean
}

export const getSaleSupply = (projectId: string) =>
  apiClient.get<SaleSupply>(`/v2/projects/${projectId}/sale/supply`)

export const setSaleSupply = (projectId: string, body: SetLinesSupplyBody) =>
  apiClient.put<SaleSupply>(`/v2/projects/${projectId}/sale/supply`, body)

export const setQuoteSupply = (projectId: string, quoteId: string, versionId: string, body: SetLinesSupplyBody) =>
  apiClient.put<LineSupply[]>(`/v2/projects/${projectId}/quotes/${quoteId}/versions/${versionId}/supply`, body)

export const getSupplyOptions = (projectId: string) =>
  apiClient.get<SupplyOption[]>(`/v2/projects/${projectId}/supply/suppliers`)
